import * as React from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import { callApi } from "../../utils/api";
import { ADMIN_ROLE } from "../../utils/role";
import isEmpty from "lodash/isEmpty";

declare var $: any;

interface AllProps {
  history: any;
}

interface CategoryItem {
  id?: number;
  category: string;
  index?: number;
}

class DocumentTypeCategoryManagement extends React.Component<AllProps> {
  state = {
    categories: [] as CategoryItem[],
    selectedCategory: { id: 0, category: "" } as CategoryItem,
    categoryToBeDeleted: 0,
    isLoading: false,
  };

  componentDidMount() {
    this.getCategories();
  }

  getCategories = () => {
    this.setState({ isLoading: true });
    callApi("GET", "document_type_category_get.php")
      .then((res) => res.data)
      .then((response) => {
        const rows = Array.isArray(response.data) ? response.data : [];
        rows.forEach((row: any, index: number) => {
          row.index = index + 1;
          row.category = row.category || "";
        });
        this.setState({ categories: rows, isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  };

  addCategory = () => {
    this.setState({ selectedCategory: { id: 0, category: "" } });
  };

  editCategory = (row: CategoryItem) => {
    this.setState({ selectedCategory: { id: Number(row.id), category: row.category } });
  };

  confirmDeleteCategory = (row: CategoryItem) => {
    this.setState({ categoryToBeDeleted: Number(row.id) });
  };

  handleChange = (e: any) => {
    const selectedCategory: any = { ...this.state.selectedCategory, category: e.target.value };
    this.setState({ selectedCategory });
  };

  saveCategory = () => {
    const { selectedCategory } = this.state;
    const category = selectedCategory.category ? selectedCategory.category.trim() : "";
    if (!category) {
      ToastsStore.error("Category is required");
      return;
    }

    const payload = {
      ...selectedCategory,
      category,
    };

    const isUpdate = !!selectedCategory.id;
    const api = isUpdate ? "document_type_category_update.php" : "document_type_category_create.php";

    callApi("POST", api, payload)
      .then((res) => res.data)
      .then((response) => {
        if (response.success) {
          $("#document-type-category-form").modal("hide");
          ToastsStore.success(isUpdate ? "Updated Successfully" : "Saved Successfully");
          this.setState({ selectedCategory: { id: 0, category: "" } });
          this.getCategories();
          return;
        }
        ToastsStore.error(response.message || "Operation failed");
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Something went wrong");
      });
  };

  deleteCategory = () => {
    callApi("POST", "document_type_category_delete.php", { id: this.state.categoryToBeDeleted })
      .then((res) => res.data)
      .then((response) => {
        if (response.success) {
          ToastsStore.success("Deleted Successfully");
        } else {
          ToastsStore.error(response.message || "Delete failed");
        }
        this.getCategories();
      })
      .catch((err) => {
        console.log(err);
        ToastsStore.error("Something went wrong");
      });
  };

  render() {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";

    const columns = [
      { header: "ID", key: "index" },
      { header: "Category", key: "category" },
      {
        header: "Actions",
        td: (row: CategoryItem) => (
          <div className="btn-group mb-2 mr-2">
            <button type="button" className="btn btn-primary">
              Action
            </button>
            <button
              type="button"
              className="btn btn-primary dropdown-toggle dropdown-toggle-split"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle Dropdown</span>
            </button>
            <div
              className="dropdown-menu"
              x-placement="top-start"
              style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                transform: "translate3d(88px, -2px, 0px)",
              }}
            >
              <a
                className="dropdown-item"
                data-toggle="modal"
                data-target="#document-type-category-form"
                onClick={() => this.editCategory(row)}
              >
                Edit
              </a>
              {role_id === ADMIN_ROLE && (
                <a
                  className="dropdown-item"
                  data-toggle="modal"
                  data-target="#delete-document-type-category"
                  onClick={() => this.confirmDeleteCategory(row)}
                >
                  Delete
                </a>
              )}
            </div>
          </div>
        ),
      },
    ];

    return (
      <section className="pcoded-main-container">
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>Document Type Category Management</h5>
                          <button
                            className="btn btn-primary"
                            style={{ float: "right" }}
                            onClick={() => this.props.history.goBack()}
                          >
                            Back
                          </button>
                        </div>
                        <div className="card-body">
                          <div className="dt-responsive table-responsive">
                            <a
                              className="btn btn-primary m-b-20"
                              data-toggle="modal"
                              data-target="#document-type-category-form"
                              onClick={this.addCategory}
                            >
                              + Add Category
                            </a>
                            {!this.state.isLoading && this.state.categories.length > 0 && (
                              <ReactFlexyTable
                                data={this.state.categories}
                                columns={columns}
                                sortable
                                globalSearch
                              />
                            )}
                            {!this.state.isLoading && this.state.categories.length === 0 && (
                              <p>No categories found.</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="document-type-category-form" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label className="col-form-label">Category:</label>
                    <input
                      type="text"
                      name="category"
                      className="form-control"
                      onChange={this.handleChange}
                      value={this.state.selectedCategory.category || ""}
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={this.saveCategory}>
                  {isEmpty(this.state.selectedCategory.id) ? "Save" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="delete-document-type-category" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Category</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h6>Are you sure you want to delete this category?</h6>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.deleteCategory}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default DocumentTypeCategoryManagement;
